import { render } from "./HomeView.vue?vue&type=template&id=316f18cc"
const script = {}

import "./HomeView.vue?vue&type=style&index=0&id=316f18cc&lang=css"

import exportComponent from "/home/runner/work/an-website/an-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__